export function getSelectorFromElement(
	element: Element,
	attribute = 'data-target',
	fallbackHref = true
): string {
	let selector = element.getAttribute(attribute);

	if (!selector && fallbackHref) {
		selector = element.getAttribute('href') || '';
		selector = /^#.*/i.test(selector) ? selector : null;
	}

	return selector;
}
